import SwalWrapper from './SwalWrapper'

export default {
    install(Vue: any) {
        Vue.prototype.$swal = new SwalWrapper()
    }
}
